module.exports = __webpack_public_path__ + "static/media/OpenSans-Italic.15f59c8a.woff2";